import Container from "react-bootstrap/Container";
import ReactGA from "react-ga";

export default function Contact() {
  const trackLinkClick = (linkType, linkText) => {
    ReactGA.event({
      category: 'contact_section',
      action: 'link_clicked',
      label: `${linkType}_${linkText}`,
      value: 1
    });
  };
  return (
    <div
      id="contact"
      className="bg-dark container-fluid"
      style={{ paddingTop: "25vh", paddingBottom: "5vh" }}
    >
      <Container style={{ maxWidth: "1000px" }} className="text-center p-3">
        <div className="text-white">
          <h1>
            FOR INQUIRIES &amp; QUESTIONS:
            <br />
          </h1>
          <p style={{ fontSize: "1.5rem" }}>
            <i className="fa fa-paper-plane fa-fw"></i>
            <a href="mailto:myke@myked.com" onClick={() => trackLinkClick('email', 'myke@myked.com')}>myke@myked.com</a>
            <br />
            <i className="fa fa-linkedin-square fa-fw"></i>
            <a href="https://www.linkedin.com/in/mykedixon" onClick={() => trackLinkClick('linkedin', 'linkedin.com/in/mykedixon')}>
              linkedin.com/in/mykedixon
            </a>
            <br />
            <i className="fa  fa-video-camera fa-fw"></i>

            <a href="https://www.imdb.com/name/nm3081444/" onClick={() => trackLinkClick('imdb', 'imdb.com/name/nm3081444')}>
              imdb.com/name/nm3081444
            </a>
            <br />
            <i className="fa  fa-file-alt fa-fw"></i>
            <a href="https://registry.jsonresume.org/gr0m17" onClick={() => trackLinkClick('resume', 'online_resume')}>Online Resume</a>
            <br />
            <i className="fa  fa-file-alt fa-fw"></i>
            <a href="myke_dixon_resume_2024.pdf" onClick={() => trackLinkClick('resume', 'pdf_resume')}>PDF Resume</a>
            <br />
            <br />
            <br />
            <br />
          </p>
        </div>
      </Container>
    </div>
  );
}
